import { render } from "./OrderReview.vue?vue&type=template&id=765db690"
import script from "./OrderReview.vue?vue&type=script&lang=js"
export * from "./OrderReview.vue?vue&type=script&lang=js"
script.render = render

export default script